let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bIwBL")).then(() => parcelRequire('7Cnic'));